import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';

import { LOCATIONS } from 'constants/index';
import cn from 'utils/classnames';

import styles from './AuthTermsNotice.module.scss';

function AuthTermsNotice({ className }) {
  return (
    <p className={cn(styles.Terms, className)}>
      Qua việc đăng nhập, bạn đồng ý với các
      {' '}
      <Link to={LOCATIONS.TERMS_OF_USE} target="_blank" rel="noopener noreferrer">
        Điều khoản và Điều kiện
      </Link>
      {' '}
      cũng như
      {' '}
      <Link to={LOCATIONS.OPERATING_RULES} target="_blank" rel="noopener noreferrer">
        Quy chế hoạt động
      </Link>
      {' '}
      của chúng tôi
    </p>
  );
}

AuthTermsNotice.propTypes = {
  className: PropTypes.string,
};

AuthTermsNotice.defaultProps = {
  className: '',
};

export default AuthTermsNotice;
